import React, { useState, useEffect } from 'react';
import { isEmpty, size } from 'lodash';
import Spin from '../../../../../../commonModules/interface/Spin';
import Photos from '../../../../../../commonModules/interface/input-files';
import InputText, { TextArea, InputSelectMagasin } from '../../../../../../commonModules/interface/form-input-inline';
import { Box, Typography, Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import PopUp from '../../../../../../commonModules/interface/PopUp';
import { Alert } from '@material-ui/lab';
import Currency from '../../../../../../commonModules/Currency';

const DetailsReturnProduct = (props) => {
    const [state, setState] = useState({
        product_photos: null,
        errors: {
            product_ref: '',
            client_ref: '',
            product_quantity: '',
            description: '',
            use_length: '',
            sell_price: '',
            actual_price: '',
            product_location: '',
            product_state: '',
        },
        sending: false,
    });

    const createShopList = () => {
        const { SHOPS } = props;
        let list = [{ value: '', label: 'Chosissez un Magasin' }];
        if (!isEmpty(props.SHOPS)) {
            Object.values(SHOPS).forEach((shop) => {
                list.push({
                    value: shop.id,
                    label: shop.name,
                    disabled: state.product_location === shop.id || !!shop.shop_disabled,
                });
            });
        }
        return list;
    };

    const setPhotos = (list) => {
        console.log('[INFO] SETPHOTOS', list);

        setState((prevState) => ({
            ...prevState,
            product_photos: list,
        }));
    };

    const handleSelect = (option, name) => {
        const value = option.value;
        const displayName = name + '_display';
        setState((prevState) => ({
            ...prevState,
            [name]: value,
            [displayName]: option,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeProductQuantity = (e) => {
        const { name, value } = e.target;
        const errors = state.errors;
        console.log('[DEBUG], handleChangeProductQuantity, ', value, ' vs , ', props.maxQuantity);
        if (value > props.maxQuantity) {
            errors['product_quantity'] = 'Quantité max est ' + props.maxQuantity;
            setState((prevState) => ({
                ...prevState,
                errors: errors,
                [name]: props.maxQuantity,
            }));
        } else {
            errors['product_quantity'] = '';
            setState((prevState) => ({
                ...prevState,
                errors: errors,
                [name]: value,
            }));
        }
    };

    const validate = () => {
        let noErrors = true;
        const errors = { ...state.errors };
        const required = [
            'product_quantity',
            'description',
            'use_length',
            'sell_price',
            'actual_price',
            'product_location',
            'product_state',
        ];
        const requiredProps = ['product_ref', 'client_ref'];
        required.forEach((field) => {
            if (isEmpty(state[field])) {
                errors[field] = 'Veuillez remplir ce champ';
                noErrors = false;
            } else {
                errors[field] = '';
            }
        });
        requiredProps.forEach((field) => {
        if (isEmpty(props[field])) {
            errors[field] = 'Veuillez remplir ce champ';
            noErrors = false;
        } else {
            errors[field] = '';
        }
        });

        console.log('[INFO] NOERRORS = ', noErrors);
        console.log('[INFO] VALIDATE, ERRORS = ', errors);

        setState((prevState) => ({
            ...prevState,
            errors: errors,
        }));

        return noErrors;
    };

    const handleSubmit = async () => {
        console.log('[DEBUG], handleSubmit, :> ', state);
        setState((prevState) => ({
            ...prevState,
            sending: true,
        }));
        if (validate()) {
            let data = {
                input_type: 'sale_return',
                sale_id: props.return_sale,
                sale_item_id: props.currentSaleItem.item_id,
                client_ref: props.client_ref,
                product_ref: props.currentProduct.id,
                description: state.description,
                use_length: state.use_length,
                sell_price: state.sell_price,
                actual_price: state.actual_price,
                product_photos: state.product_photos,
                product_location: state.product_location,
                product_state: state.product_state,
                product_quantity: parseInt(state.product_quantity),
                product_status: 'AVAILABLE',
            };
            let floats = ['use_length', 'sell_price', 'actual_price'];
            floats.forEach((field) => {
                data[field] = parseFloat(data[field]);
            });
            console.log('Submit return', { data });
            //const response = await props.createReturnProduct(data)
            props
                .createReturnProduct(data)
                .then((e) => {
                    toast.success('Produit ajouté');
                    clearForms();
                    props.next();
                })
                .catch((e) => {
                    console.log('ERROR return', JSON.stringify(e));
                    toast.error('ERROR ' + JSON.stringify(e));
                });
        }
        setState((prevState) => ({
            ...prevState,
            sending: false,
        }));
    };

    const clearForms = () => {
        setState((prevState) => ({
            ...prevState,
            product_ref_display: { value: '', label: '' },
            product_location_display: { value: '', label: '' },
            product_state_display: { value: '', label: '' },
            client_ref_display: { value: '', label: '' },

            product_ref: '',
            product_location: '',
            client_ref: '',
            product_quantity: '',
            product_state: '',
            description: '',
            use_length: '',
            sell_price: '',
            actual_price: '',
            product_photos: null,
            errors: {
                product_ref: '',
                client_ref: '',
                product_quantity: '',
                description: '',
                use_length: '',
                sell_price: '',
                actual_price: '',
                product_location: '',
                product_state: '',
            },
            sending: false,
        }));
        setPhotos([]);
    };

  return (
        <PopUp
            title={`Produit ${props.currentFormIndex || 1}/${size(props.return_list)|| 1} | ${props.currentProduct.name} - ${props.currentProduct.marque}`}
            submitAction={handleSubmit}
            submitTitle="Suivant"
            close={props.previous}
        >
            <Box p={2}>
                {state.sending && <Spin />}

                {props.sale_ref &&
                    <Alert severity="info">
                        {props.currentProduct.name} - {props.currentProduct.marque} |{' '}
                        <b>Prix Vente Unitaire: </b> <Currency value={props.currentSaleItem.priceU} /> |{' '}
                        <b>Quantité restante: </b> {props.currentSaleItem.rest_to_return} / {props.currentSaleItem.quantity}
                    </Alert>
                }
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                        <InputText
                            type="number"
                            id="product_quantity"
                            onChange={handleChangeProductQuantity}
                            value={state.product_quantity}
                            name="product_quantity"
                            title="Quantité"
                            error={state.errors.product_quantity}
                        />
                        <InputSelectMagasin
                            options={createShopList()}
                            value={state.product_location_display}
                            onChange={(option) => handleSelect(option, 'product_location')}
                            label="Magasin de retour"
                            error={state.errors.product_location}
                        />

                        <TextArea
                            type="text"
                            id="description"
                            onChange={handleChange}
                            value={state.description}
                            name="description"
                            title="Description"
                            placeholder="Description de l'état du produit"
                            rows={5}
                            error={state.errors.description}
                        />

                        <Box p={1}>
                            <Photos photoList={setPhotos} photos={state.product_photos === null ? [] : state.product_photos} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputSelectMagasin
                            options={[
                                { value: 'new', label: 'Comme Neuf' },
                                { value: 'very_good', label: 'Très bien' },
                                { value: 'good', label: 'Bien' },
                                { value: 'bad', label: 'Mauvais' },
                                //{value:"other", label:"..."},
                            ]}
                            value={state.product_state_display}
                            onChange={(option) => handleSelect(option, 'product_state')}
                            error={state.errors.product_state}
                            label="État du Produit"
                        />

                        <InputText
                            type="text"
                            id="use_length"
                            onChange={handleChange}
                            value={state.use_length}
                            name="use_length"
                            placeholder="Durée d'utilisation en Mois"
                            title="Durée d'utilisation"
                            error={state.errors.use_length}
                        />

                        <InputText
                            type="text"
                            id="actual_price"
                            onChange={handleChange}
                            value={state.actual_price}
                            name="actual_price"
                            placeholder="Valeur du Produit"
                            title="Valeur Résiduelle du Produit"
                            error={state.errors.actual_price}
                        />
                        <InputText
                            type="text"
                            id="sell_price"
                            onChange={handleChange}
                            value={state.sell_price}
                            name="sell_price"
                            title="Prix de Revente Unitaire"
                            error={state.errors.sell_price}
                        />
                    </Grid>
                </Grid>
            </Box>
        </PopUp>
    );
};

export default DetailsReturnProduct;
